import { http } from '../utils/http'

const searchTransportationAction = (params) => {
  const url = `/open/api/v1/transportation/search`
  return http.post(url, params)
};
const exportAction = (params) => {
  const url = `/config/transportation/export`
  return http.post(url, params)
};
const resendAction = (apiName,apiType,direction,params) => {
  const url = `/monitor/message/upload/resend/${apiName}/${apiType}/${direction}`
  return http.postFormData(url, params)
};
export default {
  searchTransportationAction,
  exportAction,
  resendAction,
}
